export default __webpack_public_path__ + "static/media/eletronicos.fe52706c.svg";